import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class ConfirmInfoToDate extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'All of the Information You Submitted is True, Accurate, and Up-to-Date?',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: false,
    modalTitle: null,
    additionalFormComponent: null,
    requiredToContinue: true,
    errorRequiredMessage: 'To Proceed You Must Confirm!',
  };
}
